import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Modal, Select} from 'antd';
import {useDispatch} from 'react-redux';
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import {handleQc} from "../../store/SettingRedux/SettingRedux";
import GetUsersFullName from "../UserManagement/GetUsersFullName";

const {TextArea} = Input;
const QcModal = () => {

     const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [form] = Form.useForm();


    const handleShow = () => {

        setOpen(true);

    };

    useEffect(() => {
        if (open) {
            getFilterQcStatus(setQcStatusList, setQcStatusLoading)
            GetUsersFullName(setUserList, setUserLoading)
        }
    }, [open]);
    const handleOk = () => {

    };


    const handleCancel = () => {
        setOpen(false);
    };
    const onFinish = (values) => {
        handleCancel()
        dispatch(handleQc(values))
    }
    const onFinishFailed = () => {
    }
    return (<>
            <div>
                <Button className='defBtn blueBtn' onClick={handleShow}> وضعیت کالا</Button>

                <Modal
                    open={open}
                    title='وضعیت کالا'
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[<Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>, <Button className='defBtn blueBtn' key='submit' type='primary'
                                       onClick={() => {
                                           form.submit()
                                       }}>
                        ثبت
                    </Button>,

                    ]}
                >

                    <Form form={form}
                          name="basic"
                          layout='vertical'
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          autoComplete="off"
                    >
                        <Form.Item
                            name="qcModel"
                            label="وضعیت"


                        >
                            <Select


                                loading={qcStatusLoading}
                                filterOption={(input, option) => {

                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())

                                }}
                                optionFilterProp='label'

                                options={qcStatusList}/>


                        </Form.Item>


                        <Form.Item


                            name="description"
                            label="توضیحات"


                        >
                            <TextArea row={4}/>

                        </Form.Item>


                    </Form>


                </Modal>
            </div>
        </>

    );
};
export default QcModal;